module.exports = __webpack_public_path__ + "static/media/crossword-social.d57f3301.png";